
export const DIAMOND_REQUEST_START = "DIAMOND_REQUEST_START";
export const DIAMOND_REQUEST_FAILED = "DIAMOND_REQUEST_FAILED";
export const DIAMOND_REQUEST_SUCCESS = "DIAMOND_REQUEST_SUCCESS";
export const DIAMOND_UPDATE = "DIAMOND_UPDATE";
export const DIAMOND_UPDATE_HASMORE = "DIAMOND_UPDATE_HASMORE";